export default __webpack_public_path__ + "static/media/about-us-conservation.3ba1545f.jpeg";